/** Per-game counters, as stored for each human in each counted game. */
export const STAT_COUNTERS = [
    'cardsPlayed',
    'turns',
    'rolls',
    'attacks',
    'failedAttacks',
    'kills',
    'freeKills',
    'cardsLost',
    'warsFought',
    'warsWon',
    'warsLost',
    'powersUsed',
    'fiveOfAKinds',
    'ghostRolls',
    'ghostReturns',
    'rounds',
    'durationMs',
];
/** Rate metrics only rank players with at least this many counted games. */
export const LEADERBOARD_MIN_GAMES = 5;
/** Players listed per metric. */
export const LEADERBOARD_TOP = 10;
const ratio = (n, d) => (d > 0 ? n / d : null);
const rated = (a, v) => (a.games >= LEADERBOARD_MIN_GAMES ? v : null);
/** Counters with a career total and a best game (duration and rounds read as time played / longest game). */
const COUNTER_FORMAT = Object.fromEntries(STAT_COUNTERS.map((c) => [c, c === 'durationMs' ? 'duration' : 'int']));
export const METRICS = [
    // Career totals.
    { id: 'games', kind: 'total', format: 'int', value: (a) => a.games },
    { id: 'wins', kind: 'total', format: 'int', value: (a) => a.wins },
    ...STAT_COUNTERS.map((c) => ({
        id: `total.${c}`,
        kind: 'total',
        format: COUNTER_FORMAT[c],
        value: (a) => a.sum[c],
    })),
    { id: 'forfeits', kind: 'total', format: 'int', value: (a) => a.forfeits },
    // Best single game.
    ...STAT_COUNTERS.map((c) => ({
        id: `best.${c}`,
        kind: 'best',
        format: COUNTER_FORMAT[c],
        value: (a) => a.max[c],
    })),
    { id: 'fastestWin', kind: 'best', format: 'duration', lowerIsBetter: true, value: (a) => a.fastestWinMs },
    { id: 'quickestWin', kind: 'best', format: 'int', lowerIsBetter: true, value: (a) => a.quickestWinRounds },
    { id: 'biggestWin', kind: 'best', format: 'int', value: (a) => a.biggestWin },
    // Rates (LEADERBOARD_MIN_GAMES or more).
    { id: 'winRate', kind: 'rate', format: 'pct', value: (a) => rated(a, ratio(a.wins, a.games)) },
    {
        id: 'avgPlacement',
        kind: 'rate',
        format: 'decimal',
        lowerIsBetter: true,
        value: (a) => rated(a, ratio(a.placementSum, a.games)),
    },
    { id: 'killsPerGame', kind: 'rate', format: 'decimal', value: (a) => rated(a, ratio(a.sum.kills, a.games)) },
    {
        id: 'attackSuccess',
        kind: 'rate',
        format: 'pct',
        value: (a) => rated(a, ratio(a.sum.attacks - a.sum.failedAttacks, a.sum.attacks)),
    },
    {
        id: 'warWinRate',
        kind: 'rate',
        format: 'pct',
        value: (a) => rated(a, ratio(a.sum.warsWon, a.sum.warsFought)),
    },
    {
        id: 'freeKillsPerGame',
        kind: 'rate',
        format: 'decimal',
        value: (a) => rated(a, ratio(a.sum.freeKills, a.games)),
    },
    {
        id: 'powersPerGame',
        kind: 'rate',
        format: 'decimal',
        value: (a) => rated(a, ratio(a.sum.powersUsed, a.games)),
    },
    {
        id: 'fiveOfAKindsPerGame',
        kind: 'rate',
        format: 'decimal',
        value: (a) => rated(a, ratio(a.sum.fiveOfAKinds, a.games)),
    },
    {
        id: 'cardsLostPerGame',
        kind: 'rate',
        format: 'decimal',
        lowerIsBetter: true,
        value: (a) => rated(a, ratio(a.sum.cardsLost, a.games)),
    },
];
export const METRIC_KINDS = ['total', 'best', 'rate'];
//# sourceMappingURL=leaderboard.js.map